import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class Random extends Request {
  constructor() {
    super()
  }

  get path() {
    return '/apis/random'
  }

  get method() {
    return Methods.get
  }

  decode({ data }) {
    return data.map(data => new ModelHero(data))
  }
  decodeError(error) {
    return { error: error }
  }
}
